export const googleRatingConstants = {
    GOOGLE_RATING_GET_PENDING: 'GOOGLE_RATING_GET_PENDING',
    GOOGLE_RATING_GET_FULFILLED: 'GOOGLE_RATING_GET_FULFILLED',
    GOOGLE_RATING_GET_REJECTED: 'GOOGLE_RATING_GET_REJECTED',
    GOOGLE_RATING_CLEAR: 'GOOGLE_RATING_CLEAR',
};
